import { render, staticRenderFns } from "./team-people.vue?vue&type=template&id=21aa3186&scoped=true&"
import script from "./team-people.vue?vue&type=script&lang=js&"
export * from "./team-people.vue?vue&type=script&lang=js&"
import style0 from "./team-people.vue?vue&type=style&index=0&id=21aa3186&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21aa3186",
  null
  
)

component.options.__file = "team-people.vue"
export default component.exports